import React, { useEffect, useState } from "react";
import API, { uploadUrl } from "../utils/api";

const Banner = () => {
  const [images, setImages] = useState([]);
  const [current, setCurrent] = useState(0);

  const getImageSrc = (image) => {
    if (!image) return "";
    if (image.startsWith("http")) return image;
    return `${uploadUrl}/${image}`;
  };

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await API.get("/banners");

        const bannerList = Array.isArray(response.data)
          ? response.data
          : response.data.data || [];

        setImages(bannerList);
      } catch (error) {
        console.log("Banner API Error:", error);
        setImages([]);
      }
    };

    fetchBanners();
  }, []);

  useEffect(() => {
    if (images.length <= 1) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  if (images.length === 0) return null;

  return (
    <section className="relative w-full overflow-hidden">
      <div
        className="flex transition-transform duration-700 ease-in-out"
        style={{
          width: `${images.length * 100}%`,
          transform: `translateX(-${current * (100 / images.length)}%)`,
        }}
      >
        {images.map((item, index) => (
          <div
            key={item._id || index}
            className="w-full flex-shrink-0"
            style={{ width: `${100 / images.length}%` }}
          >
            <img
              src={getImageSrc(item.image)}
              alt={item.title || `Banner ${index + 1}`}
              className="w-full h-auto object-cover"
            />
          </div>
        ))}
      </div>

      {images.length > 1 && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              aria-label={`Go to banner ${index + 1}`}
              className={`h-3 rounded-full transition-all duration-300 ${
                current === index
                  ? "w-8 bg-[#FFD700]"
                  : "w-3 bg-white/70 hover:bg-white"
              }`}
            ></button>
          ))}
        </div>
      )}
    </section>
  );
};

export default Banner;